export default __webpack_public_path__ + "static/media/logo-light.931e370b.png";